import store from '../store'
import { appUrl } from '../config'

const beforeEach = (to, from, next) => {
    const auth = to.meta.requiresAuth == undefined;
    window.scrollTo(0, 0)
    /**
    * Clears all global feedback message
    * that might be visible
    */
    store.dispatch('resetMessages')

    /**
    * If route doesn't require authentication be normally accessed.
    */
    if (auth !== true) {
        next()
        return // return to prevent the code from continuing in its flow
        // With this flow `else` or `else if` is not necessary
    }

    /**
    * Protected LMS admin route. If there is no LMS session (e.g. an approval
    * email deep-link opened while logged out), bounce to the app-side SSO
    * bridge BEFORE the target component loads/renders — this avoids the brief
    * flash of the detail page before the redirect. The intended path is carried
    * so the user is returned here after login/handoff. app/lms/services.js keeps
    * the same guard at module-load as a fallback.
    */
    var lmsUser = null;
    try { lmsUser = JSON.parse(localStorage.getItem('user')); } catch (e) { lmsUser = null; }
    if (!lmsUser) {
        var base = (appUrl || '').replace(/\/$/, '');
        var target = to.fullPath || to.path || '';
        window.location = base + '/lms-sso?redirect=' + encodeURIComponent(target);
        return; // full-page redirect; do not call next()
    }

    next() // has a session — can access the route
}

export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js